<template>
  <div
    v-if="showButtonReportes" 
    class="d-flex justify-content-end align-items-center"
  >
    <h5
      v-if="showButtonReportes" 
      class="mr-2">Reportes:
    </h5>
    <b-button 
      v-if="showButtonReportes"
      class="mr-1"
      title="Descargar Imc Excel"
      variant="outline-secondary" 
      @click="descargarImcExcel"
      :disabled = 'descargandoActual'
    > 
      <b-spinner small v-if="descargandoActual && archivodescargando === '7'"/>
      <i v-else class="fa-regular fa-file-excel"/>
    </b-button>

    <b-button
      v-if="showButtonReportes" 
      class="mr-1"
      title="Descargar Excel Sastisfaccion"
      variant="outline-secondary" 
      @click="descargarExcelSastisfaccion"
      :disabled = 'descargandoActual'
    > 
      <b-spinner small v-if="descargandoActual && archivodescargando === '9'"/>
      <i v-else class="fa-regular fa-file-excel"/>
    </b-button>

    <b-button 
      v-if="showButtonReportes"
      class="mr-1"
      title="Descargar Excel Revisiones"
      variant="outline-secondary" 
      @click="descargarExcelRevisiones"
      :disabled = 'descargandoActual'
    >
      <b-spinner small v-if="descargandoActual && archivodescargando === '2'"/>
      <i v-else class="fa-regular fa-file-excel" />
    </b-button>
    <b-button 
      v-if="showButtonReportes"
      title="Descargar Excel Tiempos"
      variant="outline-secondary" 
      @click="descargarExcelTiempos"
      :disabled = 'descargandoActual'
    >
      <b-spinner small v-if="descargandoActual && archivodescargando === '8'"/>
      <i v-else class="fa-regular fa-file -excel" />  
    </b-button>    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { comprobarPermisos, comprobarRoles } from "@/shared/helpers";
import { ROLES } from '@/shared/constants';
export default {

  name: "ReportesAtenciones",
  props: {
    downloadFinished : Boolean,
  },
  data() {
    return {
      descargandoActual : false,
      archivodescargando: null,

      filters:{
        segsalud:null,
        paciente:null,
        doctor  : null,
        especialidad: null,
        estadoRevision:null,
        fechaDesde: null,
        fechaHasta: null,
        // establecimiento: null,
        excelImc: null,
        sinDiagnosticos: null,
        porRevisar:null,
        idAtencion : null
      },

    }
  },

  async created() {
    comprobarPermisos(this.$route);
  },

  methods: {

    descargarImcExcel(){
      this.filters.excelImc = '7'
      this.archivodescargando = '7'
      this.descargandoActual = true
      if (this.stFiltros) {
        let filtros = { ...this.stFiltros };
        filtros.excelImc = '7'
        filtros.trigger = Math.floor(Math.random() * 101);
        this.$store.commit("setFilterAtenciones", filtros);
      }else { this.$store.commit("setFilterAtenciones", this.filters); }
      
    },
    descargarExcelSastisfaccion(){
      this.filters.excelImc = '9'
      this.archivodescargando = '9'
      this.descargandoActual = true
      if (this.stFiltros) {
        let filtros = { ...this.stFiltros };
        filtros.excelImc = '9'
        filtros.trigger = Math.floor(Math.random() * 101);
        this.$store.commit("setFilterAtenciones", filtros);
      }else { this.$store.commit("setFilterAtenciones", this.filters); }
      
    },


    descargarExcelRevisiones(){
      console.log("ENTRA AQUI REVISIONES DESCARGAR")
      this.filters.excelImc = '2'
      this.archivodescargando = '2'
      this.descargandoActual = true
      console.log("ENTRA AQUI REVISIONES DESCARGAR 2")


     
      if (this.stFiltros) {
        console.log("entra aqui de nuevo CIERTO")
        let filtros = { ...this.stFiltros };
        filtros.excelImc = '2';
        filtros.trigger = Math.floor(Math.random() * 101);
        this.$store.commit("setFilterAtenciones", filtros);
      } else { this.$store.commit("setFilterAtenciones", this.filters); }

    },

    descargarExcelTiempos(){
      this.filters.excelImc = '8'
      this.archivodescargando = '8'
      this.descargandoActual = true
      
      if (this.stFiltros) {
        let filtros = { ...this.stFiltros };
        filtros.excelImc = '8'
        filtros.trigger = Math.floor(Math.random() * 101);
        this.$store.commit("setFilterAtenciones", filtros);
      }else { this.$store.commit("setFilterAtenciones", this.filters); }
    },    
  },


  computed: {
    ...mapState({
      stFiltros: state => state.generals.filterAtenciones
    }),
    showButtonReportes(){
      const hasPermission = comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ESTADISTICAS, ROLES.JEFE_VALIDACIONES, ROLES.JEFE_AUDITOR, ROLES.AUDITOR, ROLES.DIGITADOR]);
      return hasPermission;
    },
  },

  watch: {
    downloadFinished(newVal){
      if(newVal === true){
        this.descargandoActual = false
      }       
    
      
    }
  }
}
</script>